// Dependencies
import React from 'react';

import { RentVsBuyInput } from '../../../../../lib/utils';
import MaintainanceFeeInput from '../maintainance-fees';

const MaintainanceFeesInputWithAnalytics: React.FC<RentVsBuyInput> = ({
  label,
  tooltip,
  className,
  fullWidth,
}) => {
  return (
    <MaintainanceFeeInput
      label={label}
      tooltip={tooltip}
      className={className}
      fullWidth={fullWidth}
    />
  );
};

export default MaintainanceFeesInputWithAnalytics;
